import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";
function FundSOrderConfirmationDetail({ confirm, bid_value, last_price_value }: any) {
  const form = useAppSelector((state) => state.orderSection.form_data);
  return (
    <>
      <div className="order-confirmation-table">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              <th>NAV</th>
              <th>Quantity</th>
              <th>Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              <td>
                <span>{confirm.security_name}</span>
                <div className="tooltiptext">
                  <p>{confirm.security_name}</p>
                </div>
              </td>
              <td>{form.direction.toLowerCase() === "buy" ? "Subscribe" : "Redeem"}</td>
              <td>{confirm.type.replace(/_/g, " ")}</td>
              <td>
                <span>GTC</span>
              </td>
              <td>
                {last_price_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                  <b>N/A</b>
                ) : (
                  <>{form.direction.toLowerCase() === "sell" && <b>{Number(confirm.price).toFixed(2)}</b>}</>
                )}
              </td>
              <td>
                <b>{form.fund_order_type !== "amount" ? formatNumber(confirm.quantity, 5) : Number(confirm.quantity).toFixed(5)}</b>
              </td>
              <td>
                {last_price_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                  <b>N/A</b>
                ) : (
                  <>
                    {form.direction.toLowerCase() === "sell" && (
                      <b>
                        ({new Intl.NumberFormat().format(confirm.quantity * confirm.price)}) {confirm.currency}
                      </b>
                    )}
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <>
          {last_price_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
            <></>
          ) : (
            <>
              {form.direction.toLowerCase() === "sell" && (
                <span className="trade-text">
                  At a NAV of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is at{" "}
                  {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} {confirm.currency}
                </span>
              )}
            </>
          )}
        </>
      </div>
    </>
  );
}

export default FundSOrderConfirmationDetail;
